module.exports = "/_next/static/images/copBackground-dfcf27865e59ec461321cd2c2c00708a.webp";